export default __webpack_public_path__ + "static/media/ubuntu-svgrepo-com.5282418a.svg";